import React, { useEffect, useState } from "react"
import { Grid } from "semantic-ui-react"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"
import Loader from "../../CommonComponent/Loader/Loader"
import { showNotification } from "../../../Actions/componentActions"
import { getProfileDetail } from "../../../Actions/ProfileAction"
import QuestionFormSection from "../../CommonComponent/QuestionsFormSection"
import { fetchFeedBackAndQuestionsData, submitFeedBackQuestion } from "../../../Services/GenericSevices/GenericSevices"
import { Paths } from "../../routes/routePaths"

const GenericFeedBackQuestions = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false)
    const { feedbackQuestionsData } = useSelector(state => state.surveyQuestionsReducers)
    const profileDetail = useSelector(state => (state.profileReducer.profileDetail));
    const [selectedAnsweredQuestions, setSelectedAnsweredQuestions] = useState([])
    const [isErrorMessage, setIsErrorMessage] = useState({
        type: '',
        message: '',
        notSelectOptions: []
    })

    useEffect(() => {
        getGenericFeedbackQuestion()
        return () => {
            dispatch({
                type: 'RESET_FEEDBACK_QUESTIONS'
            })
        }
        // eslint-disable-next-line
    }, [])

    const getGenericFeedbackQuestion = async () => {
        setIsLoading(true)
        await dispatch(fetchFeedBackAndQuestionsData("feedback"))
        setIsLoading(false)


    }

    const handleNextSubmitOption = (selectedOptionsData) => {

        let { final_ques, questions } = feedbackQuestionsData?.[0]

        if (questions.length === selectedOptionsData.length) {
            let data = [...selectedOptionsData].map(item => {
                let obj = {
                    ...item,
                    generic_question_id: item?.question_id,
                    user_id: profileDetail ? profileDetail?.data?.user?.id : ""
                }

                delete obj.question_id

                return obj
            })
            submitAnswers(data, final_ques ? final_ques : null)
        } else {
            let notSelectOptions = questions.filter(item => !selectedAnsweredQuestions.includes(item?.que_id))
            setIsErrorMessage({
                type: 'unFill all value',
                message: 'Please ensure all questions are answered before submitting the form. Your responses are important to us. Thank you for your cooperation.',
                notSelectOptions: notSelectOptions?.map(item => item?.que_id)
            })
        }
    };

    const submitAnswers = async (data, isFinalQuestion) => {
        setIsLoading(true)

        let genericDatapayload = {
            generic_response: data,
            feedback_final_ques: isFinalQuestion
        }
        let submitResponse = await dispatch(submitFeedBackQuestion(genericDatapayload));
        dispatch({
            type: 'RESET_FEEDBACK_QUESTIONS'
        })

        if (submitResponse.status === 200) {

            if (!isFinalQuestion) {
                getGenericFeedbackQuestion()
            }

            if (submitResponse?.data?.message?.length > 0 && isFinalQuestion) {
                dispatch(showNotification(true, submitResponse?.data?.message, 'success'))
                let redirectUrl = profileDetail?.generic_access ? Paths.GenericGamesAndSurvey : profileDetail?.data?.user?.udc_user ? '/games-survey' : '/prolific-dashboard'
                dispatch(getProfileDetail())
                history.push(redirectUrl)
            }

        } else {

            dispatch(showNotification(true, submitResponse?.data?.message ? submitResponse?.data?.message : submitResponse?.error?.response?.data?.message ? submitResponse?.error?.response?.data?.message : "Somthing went wrong."))

        }

        setTimeout(() => {
            setIsLoading(false)
            setSelectedAnsweredQuestions([])
        }, 500)
    }

    const handleChange = (e) => {
        let { name } = e.target

        let remainingSelectedAnswer = selectedAnsweredQuestions.includes(parseInt(name)) ? selectedAnsweredQuestions : [...selectedAnsweredQuestions, parseInt(name)]

        setSelectedAnsweredQuestions(remainingSelectedAnswer)
        setIsErrorMessage({
            type: '',
            message: '',
            notSelectOptions: isErrorMessage?.notSelectOptions?.filter(item => item !== parseInt(name))
        })

    }

    return (
        <div
            className="generic-feedback-questions talwind-dashboard mx-auto pt-24 pb-20 flex flex-col gap-6 w-full transition-all duration-300 sm:max-w-[calc(100vw-80px] md:max-w-[calc(100vw-80px)] md:pl-16"
        >
            <div
                className="flex flex-col gap-6 transition-all duration-30 md:w-[82%] lg:w-[79%] xl:w-[84.5%] 2xl:w-[86.5%] 3xl:w-[90%] md:ml-auto"
            >
                <Grid
                    className="m-0"
                    style={{ margin: 0 }}
                >
                    <Grid.Row
                        className="align-center"
                    >
                        <Grid
                            className="w-full"
                        >
                            <Grid.Row>
                                <Grid.Column
                                    width={16}
                                    className='m-auto'
                                >
                                    {
                                        isLoading ?
                                            <div className="flex items-center justify-center min-h-60">
                                                <Loader />
                                            </div>
                                            : <div className="main-content">
                                                <div>
                                                    <QuestionFormSection
                                                        QuestionsDetails={feedbackQuestionsData}
                                                        isErrorMessage={isErrorMessage}
                                                        handleonSubmit={handleNextSubmitOption}
                                                        handleOnChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                    }
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Grid.Row>
                </Grid>
            </div>
        </div>
    )
}

export default GenericFeedBackQuestions;